import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';

const PRICE_DOT_COLOR = '#1A854A';
const PRICE_INCREASE_DOT_COLOR = '#CB303F';
const PRICE_ORIGINAL_DOT_COLOR = '#64748B';
const DEAL_TYPE_COLORS = {
  Great: '#007EE5',
  Good: '#0098C2',
  Fair: '#00A38F',
  High: '#FF8216',
};

export function GraphActiveDot({
  cx = 0,
  cy = 0,
  stroke = PRICE_DOT_COLOR,
  payload = {},
  priceIncreaseDotColor = PRICE_INCREASE_DOT_COLOR,
  priceOriginalDotColor = PRICE_ORIGINAL_DOT_COLOR,
  currentPriceRadius = '6',
  defaultRadius = '4',
  dealType = '',
  setTooltipData = noop,
}) {
  let strokeColor = payload.isPriceIncrease ? priceIncreaseDotColor : stroke;
  strokeColor = payload.isOriginalPrice ? priceOriginalDotColor : strokeColor;
  strokeColor =
    dealType && payload.isCurrentPrice && DEAL_TYPE_COLORS[dealType] ? DEAL_TYPE_COLORS[dealType] : strokeColor;
  const radius = payload.isCurrentPrice ? currentPriceRadius : defaultRadius;
  const strokeWidth = payload.isCurrentPrice ? '3' : '2';
  const dotRef = useRef();

  useEffect(() => {
    if (dealType && payload.isCurrentPrice) {
      setTooltipData({ dotRef, cx, cy });
    }
  }, [cx, cy, dealType, payload.isCurrentPrice, setTooltipData]);

  return (
    <circle
      ref={dotRef}
      id={`dot-${payload.timestamp}-${payload.randomTooltipInt}`}
      key={payload.timestamp}
      r={radius}
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      fill={strokeColor}
      cx={cx}
      cy={cy}
      data-testid={`dot-${payload.timestamp}-${payload.randomTooltipInt}`}
    />
  );
}

GraphActiveDot.propTypes = {
  payload: PropTypes.shape({}),
  cx: PropTypes.number,
  cy: PropTypes.number,
  stroke: PropTypes.string,
  priceIncreaseDotColor: PropTypes.string,
  priceOriginalDotColor: PropTypes.string,
  currentPriceRadius: PropTypes.string,
  defaultRadius: PropTypes.string,
  dealType: PropTypes.string,
  setTooltipData: PropTypes.func,
};
